import React from 'react';
import axios from "axios";
import { useState } from "react"
import { Carousel, Form, Button } from 'react-bootstrap';
import { FiMapPin, FiPhone, FiMail, FiFacebook, FiInstagram, FiTwitter, FiYoutube, FiLinkedin } from "react-icons/fi";


const Contactus = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [number, setNumber] = useState('')
  const [message1, setMessage1] = useState('')
  // const [cpassword, setCpassword] = useState('')

  const [statusCode, setStatusCode] = useState('')
  const [message, setMessage] = useState('')



  const API_PATH = 'https://amosta.com/reactJs/conins.php';
  function axios2() {

    axios({
      method: 'post',
      url: API_PATH,
      headers: {
        'content-type': 'application/json'

      },
      data: {
        "name": name,
        "email": email,
        "number": number,
        "message1": message1

      }
    })
      .then(result => {
        if (result.data.statusCode === 200) {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
          window.location.reload(false)
        } else {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
        }
        console.log(result);
      })
      .catch(error => {
        console.log(error)
      });
  }


  return (
    <div>

      <div className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="assets/images/Contact-Us-Banner.jpg" className="d-none d-md-block w-100 img-fluid" alt="..." />
            <img src="assets/images/Contact us-Mobile View-3.jpg" className="d-block d-md-none w-100 img-fluid"
              alt="..." />
          </div>
        </div>
      </div>

      {/* <Carousel indicators={false} controls={false}>
        <Carousel.Item>
          <img
            className="img-fluid main-banner d-block w-100"
            src="assets/images/Contact-Us-Banner.jpg"
            alt="Main Banner"
          />
        </Carousel.Item>
      </Carousel> */}

      <div className="container contact-us-container mt-5">
        <div className="text-center">
          <h1 className='section2-heading'>Get In Touch</h1>
          {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis doloremque numquam esse voluptates unde incidunt molestias neque cum facere nisi eveniet, doloribus labore vero velit? Exercitationem in ex porro ipsum praesentium modi autem odio.</p> */}
        </div>
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className="right-container mt-5">
                <h5>{statusCode}</h5>
                <h5>{message}</h5>
                <Form autoComplete="off">
                  {/* <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                    <Form.Control type='text' placeholder='Full Name' id='fullName' onChange={(e) => setName(e.target.value)} required />
                  </FloatingLabel> */}
                  <div className='mb-3 form-floating'>
                    <input type="text" className="form-control" id="name" name='name' placeholder="Full Name" onChange={(e) => setName(e.target.value)} required />
                    <label htmlFor="name">Full Name</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="number" className="form-control" id="number" name='number' placeholder="Mobile Number" onChange={(e) => setNumber(e.target.value)} required />
                    <label htmlFor="number">Mobile Number</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="email" className="form-control" id="email" name='email' placeholder="Email" onChange={(e) => setEmail(e.target.value)} required />
                    <label htmlFor="email">Email</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <textarea id='message' name='message1' className='form-control' placeholder='Enter a Message' style={{ height: '100px' }} onChange={(e) => setMessage1(e.target.value)} required />
                    <label htmlFor="message">Enter a Message</label>
                  </div>
                  {/* <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                    <Form.Control type='email' placeholder='name@example.com' id='emailId' onChange={(e) => setEmail(e.target.value)} required />
                  </FloatingLabel>
                  <FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                    <Form.Control type='number' placeholder='Phone number' id='phone' onChange={(e) => setNumber(e.target.value)} required />
                  </FloatingLabel>
                  <FloatingLabel controlId="floatingTextarea2" label="Message" className='mb-3'>
                    <Form.Control as="textarea" placeholder="Leave a comment here" id='floatingTextarea2' style={{ height: '100px' }} onChange={(e) => setMessage1(e.target.value)} required />
                  </FloatingLabel> */}
                  <div className="submit-button mb-5">
                    <Button type='button' variant='success' onClick={axios2} className='btn w-100 p-2'>Submit</Button>
                    {/* <button type="button" className="btn submit-btn w-100 p-2" onClick={axios2}>Submit</button> */}
                  </div>
                </Form>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="left-container mt-5">
                {/* <h1 className='contact-info'>Contact Info</h1>
                <p align='justify'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus error ipsa porro numquam nulla blanditiis minima ducimus, similique, mollitia optio ratione excepturi, et aliquam molestias.</p> */}
                <div className="row">
                  <div className="col-1">
                    <p><FiMapPin /></p>
                  </div>
                  <div className="col-11">
                    <p align='justify'>301-B,  Flatted Factory Complex, Hartron Technology Park Plot No. 25A, Electronic City, Sector 18, Gurugram, Haryana 122015</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-1">
                    <p><FiPhone /></p>
                  </div>
                  <div className="col-11">
                    <p align='justify'><a href="tel:+91-8750060033">+91-87500 60033</a></p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-1">
                    <p><FiMail /></p>
                  </div>
                  <div className="col-11">
                    <p align='justify'><a href="mailto:sales@amosta.com">sales@amosta.com</a></p>
                  </div>
                </div>
                <div className="social-icons-many">
                  <div className="social-icon">
                    <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.facebook.com/amostasolutions/"><FiFacebook /></a>
                  </div>
                  <div className="social-icon">
                    <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.instagram.com/amostasolutions/?hl=en"><FiInstagram /></a>
                  </div>
                  <div className="social-icon">
                    <a className='icon' target='_blank' rel="noopener noreferrer" href="https://twitter.com/amostasolutions"><FiTwitter /></a>
                  </div>
                  <div className="social-icon">
                    <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.linkedin.com/company/amosta-solutions-pvt--ltd-/mycompany/"><FiLinkedin /></a>
                  </div>
                  <div className="social-icon">
                    <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/c/AmostaSolutions"><FiYoutube /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.3206330490707!2d77.06901101461841!3d28.499999496818702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d196c2ea9c4a7%3A0x88fb059582025d82!2sAmosta%20Solutions!5e0!3m2!1sen!2sin!4v1647838990674!5m2!1sen!2sin" style={{ width: '100%' }} height='400px' loading="lazy"></iframe>
      </div>
    </div>
  )
}
export default Contactus;